import LogStore from './LogStore';
import ReLoginStore from './ReLoginStore';
export default {
    logStore: new LogStore(),
    reloginStore: new ReLoginStore()
};

//# sourceMappingURL=index.js.map
